/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ capability: NonNullable<unknown> }} Rights_Cell_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Set {capability} explicitly" |
*
* @param {Rights_Cell_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cell_options_label = /** @type {((inputs: Rights_Cell_Options_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cell_Options_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.capability} explizit festlegen`)
	return /** @type {LocalizedString} */ (`Set ${i?.capability} explicitly`)
});